module.exports = __webpack_public_path__ + "media/images/icons/v2/file-02-68e337f10c9b955ec54578ad1ab31397.svg";